<template>
	<div>

		<groupPerson @openGroupInfo="openGroupInfo"></groupPerson>
		<groupInfo @closeGroupInfo="closeGroupInfo" v-show="infoBoolean"></groupInfo>

	</div>
</template>

<script>
	import groupInfo from "./group/groupInfo.vue"
	import groupPerson from "./group/groupPerson.vue"
	export default {
		components:{
			groupInfo:groupInfo,
			groupPerson:groupPerson
		},		
		data() {
			return {
				infoBoolean: false,
				value14: '',
				openId: 1,
				map: null,
				features: [{
					type: "wifiOnline",
					LngLat: [116.355428, 39.99123]
				}, {
					type: "wifiError",
					LngLat: [116.354428, 39.98223]
				}, {
					type: "wifiBug",
					LngLat: [116.363428, 39.97323]
				}, {
					type: "wifiOnline",
					LngLat: [116.392428, 39.96423]
				}, {
					type: "wifiOnline",
					LngLat: [116.311428, 39.95523]
				}]

			}
		},
		mounted() {
			
		},
		methods: {

			openGroupInfo: function() {
				
				this.infoBoolean=!this.infoBoolean
			},
			closeGroupInfo:function(){
				this.infoBoolean=!this.infoBoolean
			}
		}
	}
</script>

<style>
	
</style>
